var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-container"},[_c('div',{staticClass:"slot-container"},[_vm._t("default")],2),(_vm.isSerasa)?_c('div',{staticClass:"background-container"},[_c('img',{attrs:{"src":_vm.currentBaseUrl + '/img/page_image_bg.svg',"alt":"Clear Background"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }